export default "__VITE_ASSET__DH1SoWrS__"